<div matDialogTitle class="dialog-title">Update Field</div>
<mat-dialog-content>
  @for (item of savingMessage; track item) {
    <p-message [severity]="item.severity">{{item.summary}}</p-message>
  }
  <div style="width: auto; height: 250px;" class="flex-column space-between center">
    <!-- Fields Available to Update -->
    <p-select appendTo="body" mat-raised-button [options]="fieldOptions" [(ngModel)]="selectedField"
      placeholder="Field" (onChange)="selectField($event)" required="true"
      [filter]="!(deviceService.isMobile() || deviceService.isTablet())"
      [disabled]="!(fieldOptions).length"
      [virtualScroll]="true" [virtualScrollItemSize]="40">
      <ng-template let-item pTemplate="selectedItem">
        <span [ngClass]="{'required': needsSelect, 'default': !needsSelect}">{{ item.label || 'empty' }}</span>
      </ng-template>
      <ng-template let-option pTemplate="item">
        <span [ngClass]="option.styleClass">{{option.label||'empty'}}</span>
      </ng-template>
    </p-select>

    <!-- Options for Selected Field -->
    @if (fieldType === fieldTypes.PICKLIST.type || fieldType === fieldTypes.CHECKBOX.type) {
      <p-select appendTo="body" mat-raised-button [options]="valueOptions" [(ngModel)]="selectedValue"
        placeholder="Please select a field"
        [disabled]="!selectedField" (onChange)="updateField($event)"
        [virtualScroll]="true" [virtualScrollItemSize]="40">
      </p-select>
    }

    @if (fieldType === fieldTypes.MULTI_PICKLIST.type) {
      <div>
        <ah-multi-select-input
          (updateFieldEvent)="updateField($event)"
          [allOptions]="valueOptions"
          [asset]="asset"
          [selectedOptions]="selectedOptions"
          [field]="field"
          [controlName]="field.canonical_name">
        </ah-multi-select-input>
      </div>
    }

    @if (fieldType === fieldTypes.SHORT_TEXT_AREA.type) {
      <mat-form-field class="input-size">
        <input matInput  #input maxlength="100" [placeholder]=fieldName (keyup)="updateField($event)" [(ngModel)]="selectedValue" required>
        <mat-hint align="end">{{input.value?.length || 0}}/100</mat-hint>
      </mat-form-field>
    }

    @if (fieldType === fieldTypes.LONG_TEXT_AREA.type) {
      <mat-form-field class="input-size">
        <textarea matInput #input maxlength="2000" [placeholder]=fieldName (keyup)="updateField($event)" [(ngModel)]="selectedValue" required></textarea>
        <mat-hint align="end">{{input.value?.length || 0}}/2000</mat-hint>
      </mat-form-field>
    }

    @if (fieldType === fieldTypes.NUMBER.type) {
      <mat-form-field class="input-size">
        <input type="number" matInput #input [placeholder]="fieldName" (keyup)="updateField($event)" [(ngModel)]="selectedValue" required>
      </mat-form-field>
    }

    @if (fieldType === fieldTypes.CURRENCY.type) {
      <mat-form-field class="input-size">
        <input pattern="{{fieldTypes.CURRENCY.pattern ? fieldTypes.CURRENCY.pattern.pattern : ''}}"
          (keyup)="updateField($event)" matInput  #input maxlength="100" [placeholder]=fieldName [(ngModel)]="selectedValue" required>
        </mat-form-field>
      }
      @if (isMatched) {
        <div style="color: red;font-size: 14px;">
          {{fieldTypes.CURRENCY.pattern.message}}
        </div>
      }
      @if (!isTextField) {
        <p style="align-self: center;">
          {{assets.length}} selected Asset{{assets.length === 1 ? '' : 's'}} will be updated
        </p>
      }
      @if (isTextField) {
        <div>
          @if (!overwrite) {
            <p style="text-align: center; align-self: center;">
              {{assets.length}} Asset{{assets.length === 1 ? '' : 's'}} will have the text added at the begining of the existing {{fieldName}} data
            </p>
          }
          @if (overwrite && isTextField) {
            <p style="text-align: center; align-self: center;">
              {{assets.length}} Asset{{assets.length === 1 ? '' : 's'}} will have the text in {{fieldName}} replaced
            </p>
          }
        </div>
      }
      @if (assets.length > updateLimit) {
        <p style="text-align: center; max-width: 480px; color:#ff5722;">NOTE: Updating more than {{updateLimit}} assets at one time may take a while. Please be patient.</p>
      }
    </div>
    @if (isTextField) {
      <div class="flex-column space-between center">
        <mat-checkbox class="row-checkbox" [(ngModel)]="overwrite">
          Overwrite data instead
        </mat-checkbox>
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions class="flex justify-flex-end gap-20">
    <button mat-raised-button (click)="dialogRef.close()">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="!selectedField || saveDisabled || isMatched">Save</button>
  </mat-dialog-actions>
